const intialCategory:any=[];
const reducerAllCategories=(state=intialCategory,action:any)=>{
        
    switch (action.type) {
        case ("fetch_all_categories"):{            
            return action.payload;
        }
        default:{
            return state;
            
        }
    }
} 
export default reducerAllCategories;